import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
  selector: '[appDebounceUpKey]'
})
export class DebounceUpKeyDirective implements OnInit, OnDestroy {

  @Input() debounceTime = 500;
  @Output() debounceUpKey = new EventEmitter();
  private UpKeys = new Subject();
  private subscription: Subscription;

  constructor() { }

  ngOnInit() {
    this.subscription = this.UpKeys
      .pipe(
        debounceTime(this.debounceTime)
      )
      .subscribe(e => this.debounceUpKey.emit(e));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener('keyup', ['$event'])
  UpKeyEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    this.UpKeys.next(event);
  }
}
